import React from 'react';
import styled from 'styled-components';
import images from '../../Theming/images';

const Logo = styled.img``;

const ItvLogo: React.FC<React.CSSProperties> = ({ height = 15, ...rest }) => {
  return (
    <Logo
      id="itv-logo"
      src={images.Itv_logo}
      alt="Itv logo"
      style={{ ...rest }}
    />
  );
};

export default ItvLogo;
